module.exports = __webpack_public_path__ + "img/1561473725.31118306.jpg";